<template>
  <div>
    <app-title-bar>
      <app-material-icon name="key" />
      <h2 class="text-text-primary">{{ $t('profile.views.Password.password') }}</h2>
    </app-title-bar>

    <div class="layout-spacing">
      <AppCard class="pa-6" elevation="0">
        <v-form
          ref="form"
          :model-value="isFormValid"
          lazy-validation
          @submit.prevent="changePassword"
        >
          <v-row>
            <v-col cols="12" md="5">
              <PasswordTextField
                v-model="passwordOld"
                data-locator="current-password-field"
                :label="$t('profile.views.Password.currentPassword')"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="5">
              <PasswordTextField
                v-model="password"
                data-locator="new-password-field"
                :label="$t('profile.views.Password.newPassword')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <PasswordRulesDisplay
                :password="password"
                :is-not-previous-password="isNotPreviousPassword"
                class="mt-2"
                @rules-validity-changed="isFormValid = $event"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5">
              <PasswordTextField
                v-model="passwordConfirm"
                data-locator="confirm-password-field"
                :label="$t('profile.views.Password.confirmPassword')"
                :rules="[
                  (v) => !!v || $t('common.validations.fieldRequired', { fieldName: '' }),
                  (v) => (v === password) || $t('profile.views.Password.confirmPasswordError'),
                ]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <app-button
                data-locator="change-password-button"
                :disabled="(!isFormValid || (!password || !passwordOld || !passwordConfirm) || password !== passwordConfirm)"
                :loading="loading"
              >
                {{ $t('profile.views.Password.changePassword') }}
              </app-button>
            </v-col>
          </v-row>
        </v-form>
      </AppCard>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import AppCard from '@/common/AppCard.vue'
import PasswordRulesDisplay from '@/common/PasswordRulesDisplay.vue'
import PasswordTextField from '@/common/PasswordTextField.vue'
import { toast } from '@/common/utils/toast'
import { UPDATE_PASSWORD } from '@/store/modules/user/action_types'

const { mapActions, mapState } = createNamespacedHelpers('user')

export default {
  name: 'Password',
  components: {
    AppCard,
    PasswordTextField,
    PasswordRulesDisplay,
  },
  data () {
    return {
      loading: false,
      passwordOld: '',
      password: '',
      isFormValid: false,
      passwordConfirm: '',
      isNotPreviousPassword: undefined,
    }
  },
  computed: {
    ...mapState(['updatePasswordPending']),
  },
  methods: {
    ...mapActions([UPDATE_PASSWORD]),
    async changePassword () {
      if (this.$refs.form.validate()) {
        try {
          await this.UPDATE_PASSWORD({
            passwordOld: this.passwordOld,
            password: this.password,
          })
          this.isNotPreviousPassword = true
          toast.success(this.$t('profile.views.Password.newPasswordSaved'))
          this.$refs.form.resetValidation()
          this.$refs.form.reset()
        } catch (error) {
          let message = this.$t('common.msgFailErrorOccurred')

          if (error.response?.data?.errorCode === 'ERR_PASSWORD_WRONG') {
            message = this.$t('profile.views.Password.currentPasswordError')
          }

          if (error.response?.data?.errorCode === 'ERR_PASSWORD_NOT_FRESH') {
            message = this.$t('profile.views.Password.newPasswordNotFresh')
          }

          if (error.response?.data?.errorCode === 'ERR_PASSWORD_NOT_VALID') {
            if (error.response.data?.validationErrors?.includes('PASSWORD_SAME_AS_ONE_OF_PREVIOUS_PASSWORDS')) {
              this.isNotPreviousPassword = false
              message = this.$t('profile.views.Password.newPasswordNotFresh')
            }
          }

          toast.error(message)
        }
      }
    },
  },
}
</script>
